import Button from 'components/Elements/Button/Button';
import DefaultLayout from 'layouts/DefaultLayout/DefaultLayout';
import './faculties__list.scss';
import React, { useEffect, useRef, useState } from 'react';
import { $api } from 'services/service';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { setAlert, setLoading } from 'redux/authSlice';
import { useHistory, useLocation } from 'react-router-dom';
import ConfirmDialog from 'components/Elements/ConfirmDialog/ConfirmDialog';
import ErrorDialog from 'components/Elements/ErrorDialog/ErrorDialog';
import Calendar from '../../../components/Elements/Calender/Calendar';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import fileDownload from 'js-file-download';
import { useParams } from 'react-router';
import TableSubjectOnDayViewTypeGroupByDate
    from '../../../components/Elements/Table/Table-Subject-OnDay-View-Type-Group-By-Date';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

function SubjectClass() {
    let history = useHistory();
    const ref = useRef();
    const dispatch = useDispatch();
    // @ts-ignore
    const { fId, cId } = useParams();
    const [classChoose, setClassChoose] = useState('');
    const [subjects, setSubjects] = useState([]);
    const [subjectsDetails, setSubjectsDetails] = useState({
        isActive: false,
        data: { subjectSchedule: {}, subjectTeaching: {} }
    });
    const [dateStr, setDateStr] = useState(new Date());
    const [rooms, setRooms] = useState([]);
    const [classLists, setClassLists] = useState([]);
    const [modalShowSubjectSchedule, setModalShowSubjectSchedule] = useState(false);
    const [modalShowExportSubjectSchedule, setModalShowExportSubjectSchedule] = useState(false);
    const [subject, setSubject] = useState({ subjectCode: 'string', name: 'string', creditPoint: 0, facultyId: '' });
    const [faculties, setFaculties] = useState([]);
    const [subjectOnDay, setSubjectOnDay] = useState([]);
    const [faculty, setFaculty] = useState('');
    const [facultyColor, setFacultyColor] = useState('');
    const [freeTextSearch, setFreeTextSearch] = useState('');
    const [modalShow, setModalShow] = useState(false);
    const [changes, setChanges] = useState(false);
    const [classSubjectSchedule, setClassSubjectSchedule] = useState('');
    const [confirmDialog, setConfirmDialog] = useState({ isOpen: false, title: '', subTitle: '' });

    const [errDialog, setErrDialog] = useState({ isOpen: false, subTitle: '' });
    const [idDelete, setIdDelete] = useState(null);
    const [isMonth, setIsMonth] = useState({
        start: new Date(),
        end: new Date()
    });
    const [confirmDeleteSubjectDialog, setConfirmDeleteSubjectDialog] = useState({
        isOpen: false,
        title: '',
        subTitle: ''
    });
    const [calendarSubject, setCalendarSubject] = useState([{
        id: '',
        start: '',
        end: '',
        backgroundColor: '#1e3a8a',
        eventName: 'subject'
    }]);
    const [calendarExam, setCalendarExam] = useState([{
        id: '',
        title: '',
        start: '',
        end: '',
        backgroundColor: '#c42828',
        eventName: 'exam'
    }]);
    const [subjectTeaching, setSubjectTeaching] = useState({
        id: '',
        subjectId: '',
        name: '',
        startDate: new Date(),
        endDate: new Date(),
        startTime: '00:00',
        teacherId: '',
        roomIdDefault: ''
    });

    const [subjectScheduleTmp, setSubjectScheduleTmp] = useState({
        id: '',
        subjectTeachingId: '',
        subjectId: '',
        startDate: new Date(),
        endDate: new Date(),
        startTime: '08:00',
        endTime: '11:45', roomId: '',
        classId: cId,
        facultyId: fId,
        isRepeatedWeekly: false
    });

    const [subjectTeachingDetail, setSubjectTeachingDetail] = useState({
        id: ''
        , name: ''
        , subjectId: ''
        , subject: []
        , startDate: new Date()
        , endDate: new Date()
        , teacherId: ''
        , roomIdDefault: ''
        , teacher: []
    });

    const [subjectScheduleExport, setSubjectScheduleExport] = useState(
        {
            startDate: new Date(),
            endDate: new Date(new Date().setMonth(new Date().getMonth() + 6)),
            classId: cId
        }
    );

    const [timeInput, setTimeInput] = useState({
        startTime: '07:30',
        endTime: '10:45'
    });
    useEffect(() => {
        async function getFaculties() {
            try {
                dispatch(setLoading(true));
                const res: any = await $api.faculties.GetAllAndClass();
                if (res && res.result.length > 0) {
                    setFaculties(res.result);
                    if (fId && fId.length > 0) {
                        setFaculty(fId);
                    } else {
                        setFaculty(res.result[0].id);
                    }
                }
                dispatch(setLoading(false));
            } catch (e) {
                dispatch(setLoading(false));
                // show_ErrMsg(e?.response?.data?.errors?.exceptionMessage ? e?.response?.data?.errors?.exceptionMessage.title : 'Đã có lỗi xảy ra, xin vui lòng thử lại');
                let errMsg;
                let type = typeof e?.response?.data?.errors?.exceptionMessage;
                if (type === 'string') {
                    errMsg = e?.response?.data?.errors?.exceptionMessage;
                } else if (e?.response?.data?.errors?.exceptionMessage?.title) {
                    errMsg = e?.response?.data?.errors?.exceptionMessage?.title;
                } else {
                    errMsg = 'Đã có lỗi xảy ra, xin vui lòng thử lại';
                }
            }
        }

        getFaculties();
    }, []);

    async function isRepeatedWeekly_Checked(e) {
        setSubjectScheduleTmp({
            ...subjectScheduleTmp,
            isRepeatedWeekly: e.target.checked
        });
    }

    useEffect(() => {
        getSubjectOnDate(dateStr);
    }, [dateStr]);

    async function getSubjectOnDate(dateStr) {
        if (faculty || faculty.length > 0) {
            try {
                dispatch(setLoading(true));
                const res: any = await $api.schedule.subjectSchedules_GetListByDate({
                    'classId': cId,
                    'date': dateStr
                });
                if (res && res.result) {
                    if (res.result.totalRecord > 0) {
                        setSubjectOnDay(res.result.items);
                        // @ts-ignore
                        ref.current.scrollIntoView({
                            behavior: 'smooth',
                            block: 'nearest',
                            inline: 'start'
                        });
                    } else {
                        setSubjectOnDay([]);
                    }
                    dispatch(setLoading(false));
                }
            } catch (e) {
                dispatch(setLoading(false));
                // show_ErrMsg(e?.response?.data?.errors?.exceptionMessage ? e?.response?.data?.errors?.exceptionMessage.title : 'Đã có lỗi xảy ra, xin vui lòng thử lại');
                let errMsg;
                let type = typeof e?.response?.data?.errors?.exceptionMessage;
                if (type === 'string') {
                    errMsg = e?.response?.data?.errors?.exceptionMessage;
                } else if (e?.response?.data?.errors?.exceptionMessage?.title) {
                    errMsg = e?.response?.data?.errors?.exceptionMessage?.title;
                } else {
                    errMsg = 'Đã có lỗi xảy ra, xin vui lòng thử lại';
                }
                show_ErrMsg(errMsg);
            }
        }
    }


    async function getSubjects_GetLists() {
        const arraySubject = [];
        const arrayExam = [];
        if (faculty || faculty.length > 0) {
            try {
                dispatch(setLoading(true));
                const res: any = await $api.subject.subjectClass_Get({
                    'facultyId': fId,
                    'classId': cId,
                    'freeTextSearch': freeTextSearch,
                    'startTime': isMonth.start,
                    'endTime': isMonth.end
                });
                bindingClassChooseWithRequestParam();
                getSubjectsClass({
                    facultyId: fId !== undefined ? fId : subjectScheduleTmp.facultyId
                });
                if (res && res.result.length > 0) {
                    res.result.map((items: any) => {
                            if (items?.subjectTeachings.length > 0) {
                                items?.subjectTeachings.map((schedule: any) => {
                                    schedule.subjectSchedules.map((subject: any) => {
                                        const startHour = Number.parseInt(moment(subject.startDateTime + 'Z').format('HH'));
                                        let backgroundColor;

                                        if (startHour >= 17) {
                                            // Buổi tối từ 17h: màu xanh lá
                                            backgroundColor = subject.isCheckAttendance ? '#16a34a' : 'rgba(22,163,74,0.5)';
                                        } else if (startHour >= 12) {
                                            // Buổi chiều từ 12h đến <17h: màu vàng cam
                                            backgroundColor = subject.isCheckAttendance ? '#f59e0b' : 'rgba(248,176,80,0.5)';
                                        } else {
                                            // Buổi sáng <12h: màu xanh dương
                                            backgroundColor = subject.isCheckAttendance ? '#1e3a8a' : 'rgba(30,58,138,0.5)';
                                        }

                                        arraySubject.push({
                                            // @ts-ignore
                                            id: subject.id,
                                            // @ts-ignore
                                            title: `<b>${items.name + ' - ' + schedule.name}</b><br/><span>${'GV: ' + schedule.teacher.fullName}</span><br/><span>${'Phòng: ' + subject.room.name}</span><br/><span>${moment(subject.startDateTime + 'Z').format(
                                                'HH:mm'
                                            )} - ${moment(subject.endDateTime + 'Z').format(
                                                'HH:mm'
                                            )}</span>
                                            ${subject.isCheckAttendance ? '<span class="inline-block mt-1 px-2 py-1 rounded bg-green-100 text-green-800 border border-green-300 font-medium">Đã điểm danh</span>' : ''}`,
                                            // @ts-ignore
                                            start: moment(subject.startDateTime + 'Z').format('YYYY-MM-DD'),
                                            // @ts-ignore
                                            end: moment(subject.endDateTime + 'Z').format('YYYY-MM-DD'),
                                            // @ts-ignore
                                            backgroundColor: backgroundColor,
                                            // @ts-ignore
                                            eventName: 'subject',
                                            // @ts-ignore
                                            scheduleName: subject.name
                                        });
                                    });
                                    schedule.exams.map((item: any) => {
                                        arrayExam.push({
                                            // @ts-ignore
                                            title: `<b>${items.name + ' - ' + schedule.name}</b><br><b>${'Lịch thi:' + item?.name}</b><br><span>${'Phòng: ' + item.roomName}</span><br/><b>${moment(item.startDate + 'Z').format(
                                                'HH:mm'
                                            )} - ${moment(item.endDate + 'Z').format(
                                                'HH:mm'
                                            )}</b>`,
                                            // @ts-ignore
                                            start: moment(item.startDate + 'Z').format('YYYY-MM-DD'),
                                            // @ts-ignore
                                            end: moment(item.endDate + 'Z').format('YYYY-MM-DD'),
                                            // @ts-ignore
                                            backgroundColor: '#c42828',
                                            // @ts-ignore
                                            eventName: 'exam'
                                        });
                                    });
                                });
                            }

                        }
                    );
                    // @ts-ignore
                    setCalendarSubject(() => arraySubject);
                    // @ts-ignore
                    setCalendarExam(() => arrayExam);
                    dispatch(setLoading(false));
                } else {
                    // @ts-ignore
                    setCalendarSubject(() => []);
                    // @ts-ignore
                    setCalendarExam(() => []);
                }
                dispatch(setLoading(false));
            } catch (e) {
                dispatch(setLoading(false));
                // show_ErrMsg(e?.response?.data?.errors?.exceptionMessage ? e?.response?.data?.errors?.exceptionMessage.title : 'Đã có lỗi xảy ra, xin vui lòng thử lại');
                let errMsg;
                let type = typeof e?.response?.data?.errors?.exceptionMessage;
                if (type === 'string') {
                    errMsg = e?.response?.data?.errors?.exceptionMessage;
                } else if (e?.response?.data?.errors?.exceptionMessage?.title) {
                    errMsg = e?.response?.data?.errors?.exceptionMessage?.title;
                } else {
                    errMsg = 'Đã có lỗi xảy ra, xin vui lòng thử lại';
                }
                show_ErrMsg(errMsg);
            }
        }
    }


    useEffect(() => {
        setSubjectsDetails({ isActive: false, data: { subjectSchedule: {}, subjectTeaching: {} } });
        setCalendarSubject([{
            id: '',
            start: '',
            end: '',
            backgroundColor: '#1e3a8a',
            eventName: 'subject'
        }]);
        getSubjectsClass({
            facultyId: faculty || faculty.length > 0 ? faculty : null,
            freeTextSearch: freeTextSearch || freeTextSearch.length > 0 ? freeTextSearch : null
        });
        getSubjects_GetLists();
        setSubjectScheduleExport({ ...subjectScheduleExport, classId: cId });
    }, [isMonth, faculty, changes, cId]);

    async function getSubjectsClass(option = {}) {
        try {
            dispatch(setLoading(true));
            const res: any = await $api.subject.getPaging(option);
            if (res && res.result.items.length > 0) {
                setSubjects(res.result.items);
                await getClass(res.result.items[0].id);
            } else if (res && res.result.length === 0) {
                setSubjects([]);
            }
            dispatch(setLoading(false));
        } catch (e) {
            dispatch(setLoading(false));
            // show_ErrMsg(e?.response?.data?.errors?.exceptionMessage ? e?.response?.data?.errors?.exceptionMessage.title : 'Đã có lỗi xảy ra, xin vui lòng thử lại');
            let errMsg;
            let type = typeof e?.response?.data?.errors?.exceptionMessage;
            if (type === 'string') {
                errMsg = e?.response?.data?.errors?.exceptionMessage;
            } else if (e?.response?.data?.errors?.exceptionMessage?.title) {
                errMsg = e?.response?.data?.errors?.exceptionMessage?.title;
            } else {
                errMsg = 'Đã có lỗi xảy ra, xin vui lòng thử lại';
            }
            show_ErrMsg(errMsg);
        }
    }

    async function getSubjectTeaching(id) {
        try {
            dispatch(setLoading(true));
            if (faculty) {
                const res: any = await $api.schedule.subjectSchedule_get(id);
                if (res && res.result) {
                    subjectTeachingDetail.endDate = res.result.endDateTime;
                    subjectTeachingDetail.name = '';
                    subjectTeachingDetail.roomIdDefault = res.result.roomId;
                    subjectTeachingDetail.startDate = res.result.startDateTime;
                    subjectTeachingDetail.subject = [];
                    subjectTeachingDetail.subjectId = res.result.subjectTeachingId;
                    subjectTeachingDetail.teacher = [];
                    subjectTeachingDetail.teacherId = '';
                    subjectTeachingDetail.id = res.result.id;
                    setSubjectTeachingDetail(subjectTeachingDetail);
                    setTimeInput({
                        endTime: moment(res.result.endDateTime + 'Z').format('HH:mm'),
                        startTime: moment(res.result.startDateTime + 'Z').format('HH:mm')
                    });
                    const resSubject: any = await $api.schedule.subjectTeaching_get(res.result.subjectTeachingId);
                    if (resSubject && resSubject.result) {
                        setTimeout(() => {
                            setSubjectsDetails({
                                isActive: true,
                                data: { subjectSchedule: res.result, subjectTeaching: resSubject.result }
                            });

                        }, 100);
                        await isCreateSubjectSchdule('');
                    }
                }
            }
            dispatch(setLoading(false));
        } catch (e) {
            dispatch(setLoading(false));
            // show_ErrMsg(e?.response?.data?.errors?.exceptionMessage ? e?.response?.data?.errors?.exceptionMessage.title : 'Đã có lỗi xảy ra, xin vui lòng thử lại');
            let errMsg;
            let type = typeof e?.response?.data?.errors?.exceptionMessage;
            if (type === 'string') {
                errMsg = e?.response?.data?.errors?.exceptionMessage;
            } else if (e?.response?.data?.errors?.exceptionMessage?.title) {
                errMsg = e?.response?.data?.errors?.exceptionMessage?.title;
            } else {
                errMsg = 'Đã có lỗi xảy ra, xin vui lòng thử lại';
            }
            show_ErrMsg(errMsg);
        }
    }

    async function deleteItem() {
        setConfirmDialog({ isOpen: false, title: '', subTitle: '' });
        try {
            dispatch(setLoading(true));
            const res: any = await $api.schedule.subjectSchedule_Delete(idDelete);
            if (res) {
                dispatch(
                    setAlert({
                        type: 'success',
                        title: res.message
                    })
                );
                setModalShowSubjectSchedule(false);
                setTimeout(() => {
                    getSubjects_GetLists();
                }, 300);
            }
            dispatch(setLoading(false));
        } catch (e) {
            dispatch(setLoading(false));
            setConfirmDeleteSubjectDialog({ isOpen: false, title: '', subTitle: '' });
            setModalShowSubjectSchedule(false);
            let errMsg;
            let type = typeof e?.response?.data?.errors?.exceptionMessage;
            if (type === 'string') {
                errMsg = e?.response?.data?.errors?.exceptionMessage;
            } else if (e?.response?.data?.errors?.exceptionMessage?.title) {
                errMsg = e?.response?.data?.errors?.exceptionMessage?.title;
            } else {
                errMsg = 'Đã có lỗi xảy ra, xin vui lòng thử lại';
            }
            show_ErrMsg(errMsg);
        }
    }

    function setDatWithTime(date, time) {
        const hour = time.split(':')[0] || 9;
        const min = time.split(':')[1] || 0;
        if ((Number.parseInt(time) - 7) >= 10) {
            return moment(date).format('YYYY-MM-DD') + 'T' + (Number(hour) - 7) + ':' + min + ':00.000Z';
        } else {
            return moment(date).format('YYYY-MM-DD') + 'T' + '0' + (Number(hour) - 7) + ':' + min + ':00.000Z';
        }
    }

    async function onSaveSubjectSchedule() {
        if (!subjectScheduleTmp.isRepeatedWeekly) {
            if (setDatWithTime(subjectScheduleTmp.startDate, timeInput.endTime) <= setDatWithTime(subjectScheduleTmp.startDate, timeInput.startTime)) {
                show_ErrMsg('Thời gian buổi học không hợp lệ. Vui lòng kiểm tra lại');
                return;
            }
        } else {
            if (setDatWithTime(subjectScheduleTmp.endDate, timeInput.endTime) <= setDatWithTime(subjectScheduleTmp.startDate, timeInput.startTime)) {
                show_ErrMsg('Thời gian buổi học không hợp lệ. Vui lòng kiểm tra lại');
                return;
            }
        }

        try {
            dispatch(setLoading(true));
            const postData = {
                // @ts-ignore
                subjectTeachingId: subjectScheduleTmp.subjectTeachingId == '' ? classLists[0].id : subjectScheduleTmp.subjectTeachingId,
                classId: cId,
                facultyId: fId,
                startDateTime: setDatWithTime(subjectScheduleTmp.startDate, timeInput.startTime),
                endDateTime: setDatWithTime(subjectScheduleTmp.isRepeatedWeekly ? subjectScheduleTmp.endDate : subjectScheduleTmp.startDate, timeInput.endTime),
                // @ts-ignore
                roomId: subjectScheduleTmp.roomId == '' ? rooms[0].id : subjectScheduleTmp.roomId
            };
            if (subjectScheduleTmp.isRepeatedWeekly) {
                const res: any = await $api.schedule.subjectSchedule_createRepeat(postData);
                dispatch(
                    setAlert({
                        title: res.message
                    })
                );
            } else {
                const res: any = await $api.schedule.subjectSchedule_create([postData]);
                dispatch(
                    setAlert({
                        title: res.message
                    })
                );
            }
            setSubjectScheduleTmp({
                id: '',
                subjectTeachingId: '',
                subjectId: '',
                startDate: new Date(),
                endDate: new Date(),
                startTime: '08:00',
                endTime: '11:30',
                facultyId: fId,
                classId: cId,
                roomId: subjectTeachingDetail.roomIdDefault,
                isRepeatedWeekly: false
            });
            setTimeInput({
                startTime: '08:00',
                endTime: '11:30'
            });
            setModalShowSubjectSchedule(false);
            setChanges(!changes);
            dispatch(setLoading(false));

        } catch (e) {
            dispatch(setLoading(false));
            let errMsg;
            let type = typeof e?.response?.data?.errors?.exceptionMessage;
            if (type === 'string') {
                errMsg = e?.response?.data?.errors?.exceptionMessage;
            } else if (e?.response?.data?.errors?.exceptionMessage?.title) {
                errMsg = e?.response?.data?.errors?.exceptionMessage?.title;
            } else {
                errMsg = 'Đã có lỗi xảy ra, xin vui lòng thử lại';
            }
            show_ErrMsg(errMsg);
        }
    }

    async function isDeleteSubjectSchedule() {
        setConfirmDialog({
            isOpen: true
            , title: 'Thông báo'
            , subTitle: 'Bạn có chắc muốn xóa ?'
        });
        // @ts-ignore
        setIdDelete(subjectScheduleTmp.id);
    }

    async function onUpdateSubjectSchedule() {
        if (!subjectScheduleTmp.isRepeatedWeekly) {
            if (setDatWithTime(subjectScheduleTmp.startDate, timeInput.endTime) <= setDatWithTime(subjectScheduleTmp.startDate, timeInput.startTime)) {
                show_ErrMsg('Thời gian buổi học không hợp lệ. Vui lòng kiểm tra lại');
                return;
            }
        } else {
            if (setDatWithTime(subjectScheduleTmp.endDate, timeInput.endTime) <= setDatWithTime(subjectScheduleTmp.startDate, timeInput.startTime)) {
                show_ErrMsg('Thời gian buổi học không hợp lệ. Vui lòng kiểm tra lại');
                return;
            }
        }

        try {
            const postData = {
                // @ts-ignore
                id: subjectScheduleTmp.id !== null || '' ? subjectsDetails.data.subjectSchedule.id : subjectScheduleTmp.id,
                startDateTime: setDatWithTime(subjectScheduleTmp.startDate, timeInput.startTime),
                endDateTime: setDatWithTime(subjectScheduleTmp.startDate, timeInput.endTime),
                classId: cId,
                facultyId: fId,
                // @ts-ignore
                roomId: subjectScheduleTmp.roomId
            };
            const res: any = await $api.schedule.subjectSchedule_update(postData);
            if (res) {
                setTimeout(() => {
                    getSubjects_GetLists();
                }, 300);
            }
            dispatch(
                setAlert({
                    title: res.message
                })
            );
            setSubjectScheduleTmp({
                id: '',
                subjectTeachingId: '',
                subjectId: '',
                startDate: new Date(),
                endDate: new Date(),
                startTime: '08:00',
                endTime: '11:30', facultyId: fId,
                classId: cId,
                roomId: '',
                isRepeatedWeekly: false
            });
            setTimeInput({
                startTime: '08:00',
                endTime: '11:30'
            });
            setModalShowSubjectSchedule(false);
        } catch (e) {
            dispatch(setLoading(false));
            let errMsg;
            let type = typeof e?.response?.data?.errors?.exceptionMessage;
            if (type === 'string') {
                errMsg = e?.response?.data?.errors?.exceptionMessage;
            } else if (e?.response?.data?.errors?.exceptionMessage?.title) {
                errMsg = e?.response?.data?.errors?.exceptionMessage?.title;
            } else {
                errMsg = 'Đã có lỗi xảy ra, xin vui lòng thử lại';
            }
            show_ErrMsg(errMsg);
        }
    }

    async function onSaveContinueSubjectSchedule() {
        if (!subjectScheduleTmp.isRepeatedWeekly) {
            if (setDatWithTime(subjectScheduleTmp.startDate, timeInput.endTime) <= setDatWithTime(subjectScheduleTmp.startDate, timeInput.startTime)) {
                show_ErrMsg('Thời gian buổi học không hợp lệ. Vui lòng kiểm tra lại');
                return;
            }
        } else {
            if (setDatWithTime(subjectScheduleTmp.endDate, timeInput.endTime) <= setDatWithTime(subjectScheduleTmp.startDate, timeInput.startTime)) {
                show_ErrMsg('Thời gian buổi học không hợp lệ. Vui lòng kiểm tra lại');
                return;
            }
        }
        try {
            // dispatch(setLoading(true));
            const postData = {
                // @ts-ignore
                subjectTeachingId: subjectScheduleTmp.subjectTeachingId == '' ? classLists[0].id : subjectScheduleTmp.subjectTeachingId,
                startDateTime: setDatWithTime(subjectScheduleTmp.startDate, timeInput.startTime),
                endDateTime: setDatWithTime(subjectScheduleTmp.isRepeatedWeekly ? subjectScheduleTmp.endDate : subjectScheduleTmp.startDate, timeInput.endTime),
                // @ts-ignore
                roomId: subjectScheduleTmp.roomId == '' ? rooms[0].id : subjectScheduleTmp.roomId
            };
            if (subjectScheduleTmp.isRepeatedWeekly) {
                const res: any = await $api.schedule.subjectSchedule_createRepeat(postData);
                dispatch(
                    setAlert({
                        title: res.message
                    })
                );
            } else {
                const res: any = await $api.schedule.subjectSchedule_create([postData]);
                dispatch(
                    setAlert({
                        title: res.message
                    })
                );
            }
            setSubjectScheduleTmp({
                ...subjectScheduleTmp,
                id: '',
                subjectTeachingId: '',
                // startDate: subjectTeachingDetail.startDate,
                // endDate: subjectTeachingDetail.startDate,
                startTime: '08:00',
                endTime: '11:30', facultyId: fId,
                classId: cId,
                roomId: subjectTeachingDetail.roomIdDefault
                // isRepeatedWeekly: false
            });
            setTimeInput({
                startTime: '08:00',
                endTime: '11:30'
            });
            setChanges(!changes);
            dispatch(setLoading(false));
        } catch (e) {
            dispatch(setLoading(false));
            let errMsg;
            let type = typeof e?.response?.data?.errors?.exceptionMessage;
            if (type === 'string') {
                errMsg = e?.response?.data?.errors?.exceptionMessage;
            } else if (e?.response?.data?.errors?.exceptionMessage?.title) {
                errMsg = e?.response?.data?.errors?.exceptionMessage?.title;
            } else {
                errMsg = 'Đã có lỗi xảy ra, xin vui lòng thử lại';
            }
            show_ErrMsg(errMsg);
        }
    }

    async function isCreateSubjectSchdule(eventName: string) {
        try {
            if (eventName == 'class') {
                setClassSubjectSchedule('');
                subjectScheduleTmp.id = '';
                subjectScheduleTmp.subjectTeachingId = subjectTeachingDetail.id;
                subjectScheduleTmp.startDate = subjectTeachingDetail.startDate;
                subjectScheduleTmp.endDate = subjectTeachingDetail.endDate;
                subjectScheduleTmp.startTime = '08:00';
                subjectScheduleTmp.endTime = '11:30';
                subjectScheduleTmp.roomId = subjectTeachingDetail.roomIdDefault;
                setSubjectScheduleTmp(subjectScheduleTmp);
            } else {
                // @ts-ignore
                setClassSubjectSchedule(eventName);
                subjectScheduleTmp.id = subjectTeachingDetail.id;
                subjectScheduleTmp.subjectTeachingId = subjectTeachingDetail.subjectId;
                subjectScheduleTmp.startDate = subjectTeachingDetail.startDate;
                subjectScheduleTmp.endDate = subjectTeachingDetail.endDate;
                subjectScheduleTmp.startTime = '08:00';
                subjectScheduleTmp.endTime = '11:30';
                subjectScheduleTmp.roomId = subjectTeachingDetail.roomIdDefault;
                setSubjectScheduleTmp(subjectScheduleTmp);
            }
            setModalShowSubjectSchedule(true);
        } catch (e) {
        }
    }

    useEffect(() => {
        async function getRooms() {
            try {
                dispatch(setLoading(true));
                const res: any = await $api.room.getAll();
                if (res['result'].length !== 0) {
                    setRooms(res.result);
                    setSubjectTeaching({
                        ...subjectTeaching,
                        roomIdDefault: res.result[0].id
                    });
                } else {
                    setSubjectTeaching({
                        ...subjectTeaching,
                        roomIdDefault: ''
                    });
                }
                dispatch(setLoading(false));
            } catch (e) {
                dispatch(setLoading(false));
                let errMsg;
                let type = typeof e?.response?.data?.errors?.exceptionMessage;
                if (type === 'string') {
                    errMsg = e?.response?.data?.errors?.exceptionMessage;
                } else if (e?.response?.data?.errors?.exceptionMessage?.title) {
                    errMsg = e?.response?.data?.errors?.exceptionMessage?.title;
                } else {
                    errMsg = 'Đã có lỗi xảy ra, xin vui lòng thử lại';
                }
                show_ErrMsg(errMsg);
            }
        }

        getRooms();
    }, []);

    function show_ErrMsg(msg) {
        setErrDialog({
            isOpen: true
            , subTitle: msg
        });
    }

    function goToSchedule(id) {
        window.scrollTo({
            top: 0,
            left: 100,
            behavior: 'smooth'
        });
        history.push(`/lich-hoc-mon-chitiet/${id}`);
    }

    async function getClass(id) {
        setSubjectScheduleTmp({
            ...subjectScheduleTmp,
            subjectId: id
        });
        try {
            dispatch(setLoading(true));
            const res: any = await $api.schedule.subjectTeaching_getPaging({
                subjectId: id
            });
            if (res['result'].items.length > 0) {
                setClassLists(res.result.items);
                setSubjectScheduleTmp({
                    ...subjectScheduleTmp,
                    subjectId: id,
                    subjectTeachingId: res.result.items[0].id,
                    startDate: res.result.items[0].startDate,
                    endDate: res.result.items[0].endDate
                });
            } else {
                setClassLists([]);
                setSubjectScheduleTmp({
                    ...subjectScheduleTmp,
                    subjectTeachingId: ''
                });
            }
            dispatch(setLoading(false));
        } catch (e) {
            dispatch(setLoading(false));
            let errMsg;
            let type = typeof e?.response?.data?.errors?.exceptionMessage;
            if (type === 'string') {
                errMsg = e?.response?.data?.errors?.exceptionMessage;
            } else if (e?.response?.data?.errors?.exceptionMessage?.title) {
                errMsg = e?.response?.data?.errors?.exceptionMessage?.title;
            } else {
                errMsg = 'Đã xảy ra lỗi vui lòng thử lại';
            }
            show_ErrMsg(errMsg);
        }
    }

    function changeClass(id: string) {
        setSubjectScheduleTmp({
            ...subjectScheduleTmp,
            subjectTeachingId: id,
            // @ts-ignore
            startDate: classLists.find(// @ts-ignore
                (item) => item.id === id).startDate,
            // @ts-ignore
            endDate: classLists.find(// @ts-ignore
                (item) => item.id === id).endDate
        });
    }

    function exportSubjectSch() {
        setModalShowExportSubjectSchedule(true);
    }

    async function exportSubjectSchedules() {
        try {
            dispatch(setLoading(true));
            const res: any = await $api.schedule.subjectSchedulesExport(subjectScheduleExport);
            if (res) {
                // @ts-ignore
                fileDownload(res, `TKB_${classChoose.toUpperCase()}_TU_${moment(subjectScheduleExport.startDate).format('DD/MM/YYYY')}_DEN_${moment(subjectScheduleExport.endDate).format('DD/MM/YYYY')}.xlsx`);
                setSubjectScheduleExport({
                    startDate: new Date(),
                    endDate: new Date(new Date().setMonth(new Date().getMonth() + 6)),
                    classId: cId
                });
            }
            dispatch(setLoading(false));
            setModalShowExportSubjectSchedule(false);
        } catch (e) {
            dispatch(setLoading(false));
            // show_ErrMsg(e?.response?.data?.errors?.exceptionMessage ? e?.response?.data?.errors?.exceptionMessage.title : 'Đã có lỗi xảy ra, xin vui lòng thử lại');
            let errMsg;
            let type = typeof e?.response?.data?.errors?.exceptionMessage;
            if (type === 'string') {
                errMsg = e?.response?.data?.errors?.exceptionMessage;
            } else if (e?.response?.data?.errors?.exceptionMessage?.title) {
                errMsg = e?.response?.data?.errors?.exceptionMessage?.title;
            } else {
                errMsg = 'Đã có lỗi xảy ra, xin vui lòng thử lại';
            }
            show_ErrMsg(errMsg);
        }
    }

    function getScheduleDetails(e, faculty, classInfo) {
        e.stopPropagation();
        history.push(`/thoi-khoa-bieu-lop/${faculty.id}/${classInfo.id}`);
        setFaculty(() => faculty.id);
        setFacultyColor(() => faculty.colorCode);
    }

    function bindingClassChooseWithRequestParam() {
        if (fId && cId) {
            // @ts-ignore
            const faculty = faculties.find(faculty => faculty.id === fId);
            // @ts-ignore
            const classInfo = faculty.classes.find(cls => cls.id === cId);
            // @ts-ignore
            setClassChoose(() => `Khoa: ${faculty.name} - Lớp: ${classInfo.name}`);
            setSubjectScheduleTmp({ ...subjectScheduleTmp, facultyId: fId, classId: cId });
        } else {
            setClassChoose(() => '');
        }
    }

    function findClassWithFacultyId() {
        // @ts-ignore
        return faculties.find(item => item.id === fId)?.classes;
    }

    // @ts-ignore
    return (
        <DefaultLayout>
            <div className='subject page'>
                <div className='page__header'>
                    <div className='___title flex items-center'>
                        <div className='___title__decorate' />
                        <div>Thời khóa biểu theo lớp</div>
                    </div>
                </div>
                <div className='page__content bg-white mt-3'>
                    <div className='actions flex items-center  justify-between'>
                        <div className='flex justify-between items-end'>
                            <div className='group inline-block'>
                                <div className='pl-1 text-sm font-semibold mb-2 text-gray-600 '>
                                    Lớp
                                </div>
                                <button
                                    className='outline-none focus:outline-none border px-3 py-1 bg-white rounded-sm flex items-center min-w-64 text-1xl'
                                >
                                    <span
                                        className='pr-1 font-semibold flex-1'>{classChoose == '' ? 'Chọn lớp' : classChoose}</span>
                                    <span>
                                      <svg
                                          className='fill-current h-4 w-4 transform group-hover:-rotate-180
                                        transition duration-150 ease-in-out'
                                          xmlns='http://www.w3.org/2000/svg'
                                          viewBox='0 0 20 20'
                                      >
                                        <path
                                            d='M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z'
                                        />
                                      </svg>
                                    </span>
                                </button>
                                <ul
                                    className='bg-white border rounded-sm transform scale-0 group-hover:scale-100 absolute
  transition duration-150 ease-in-out origin-top min-w-32 z-10 cursor-pointer'
                                >
                                    {faculties.map((faculty: any) => {
                                        return (
                                            <li className='rounded-sm relative px-3 py-1 hover:bg-gray-100'
                                                key={faculty.id}>
                                                <button
                                                    className='w-full text-left flex items-center outline-none focus:outline-none'
                                                >
                                                    <span className='pr-1 flex-1'>{faculty.name}</span>
                                                    <span className='mr-auto'>
                                                      <svg
                                                          className='fill-current h-4 w-4
                                                        transition duration-150 ease-in-out'
                                                          xmlns='http://www.w3.org/2000/svg'
                                                          viewBox='0 0 20 20'
                                                      >
                                                        <path
                                                            d='M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z'
                                                        />
                                                      </svg>
                                                    </span>
                                                </button>
                                                <ul className='bg-white border rounded-sm absolute top-0 right-0 transition duration-150 ease-in-out origin-top-left min-w-32'>
                                                    {
                                                        faculty.classes.length > 0 ? faculty.classes.map(classItem => {
                                                            return <li key={classItem.id}
                                                                // @ts-ignore
                                                                       className='px-3 py-1 hover:bg-gray-100'
                                                                       onClick={(e) => getScheduleDetails(e, faculty, classItem)}>{classItem.name}</li>;
                                                        }) : <li className='px-3 py-1 hover:bg-gray-100'>Chưa có lớp phù
                                                            hợp</li>
                                                    }
                                                </ul>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>
                        </div>
                        <div />
                        <div className='action--item flex align-items-center justify-content-start'>
                            <div
                                className='actions--item'
                                onClick={(e) => {
                                    isCreateSubjectSchdule('faculty');
                                }}>
                                <Button
                                    label='Tạo thời khóa biểu mới'
                                    icon={<i className='fas fa-calendar-plus' />}
                                />
                            </div>
                            <div
                                className='actions--item ml-2'
                                onClick={(e) => {
                                    exportSubjectSch();
                                }}>
                                <Button
                                    color={'bg-green-800'}
                                    hoverColor={'bg-green-900'}
                                    label='Xuất thời khóa biểu'
                                    icon={<i className='fas fa-file' />}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='page__content bg-white mt-3'>
                    <Calendar
                        data={Array.prototype.concat(calendarSubject, calendarExam)}
                        isEventClicked={id => getSubjectTeaching(id)}
                        isEventDateClicked={dateStr => setDateStr(dateStr)}
                        isEventChangeMonthClicked={(startStr, endStr) => setIsMonth({
                            start: startStr,
                            end: endStr
                        })}
                    />
                </div>
                {
                    // @ts-ignore
                    subjectOnDay.length > 0 ? <div className='page__content bg-white mt-3' ref={ref}>
                        <TableSubjectOnDayViewTypeGroupByDate data={subjectOnDay}
                                                              dateChoose={dateStr}
                                                              clicked={(e, subjectTeachingId) => goToSchedule(subjectTeachingId)} />
                    </div> : ''
                }
            </div>
            <div>
                <Modal
                    show={modalShowSubjectSchedule}
                    aria-labelledby='contained-modal-title-vcenter'
                    onHide={() => setModalShowSubjectSchedule(false)}
                    centered>
                    <Modal.Header closeButton>
                        {
                            // @ts-ignore
                            !classSubjectSchedule?.length > 0 ? <Modal.Title id='contained-modal-title-vcenter'>
                                <div className={'flex flex-column'}>
                                    Cập nhật lịch học
                                </div>
                            </Modal.Title> : <Modal.Title id='contained-modal-title-vcenter'>
                                <div className={'flex flex-column'}>
                                    Tạo mới lịch học
                                </div>
                            </Modal.Title>
                        }
                    </Modal.Header>
                    <Modal.Body>
                        {
                            classSubjectSchedule.length ? <div className='flex center'>
                                <div className='pl-1 text-sm font-semibold mb-2 text-gray-600 '>
                                    Lặp lại hằng tuần
                                </div>
                                <input
                                    type='checkbox'
                                    className='h-4 w-4 mt-0.5 ml-4'
                                    // @ts-ignore
                                    checked={subjectScheduleTmp.isRepeatedWeekly}
                                    onChange={(e) => {
                                        isRepeatedWeekly_Checked(e);
                                    }}
                                />
                            </div> : <div>
                                <div className='mt-2 w-100'>
                                    <div className='pl-1 font-semibold mb-2 text-gray-600 '>
                                        Khoa: <span className={'text-danger'}>{
                                        // @ts-ignore
                                        subjectsDetails.data.subjectTeaching.subject?.facultyName}</span>
                                    </div>
                                </div>
                                <div className='mt-2 w-100'>
                                    <div className='pl-1 font-semibold mb-2 text-gray-600 '>
                                        Môn: <span className={'text-danger'}>{
                                        // @ts-ignore
                                        subjectsDetails.data.subjectTeaching.subject?.name}</span>
                                    </div>
                                </div>
                                <div className='mt-2 w-100'>
                                    <div className='pl-1 font-semibold mb-2 text-gray-600 '>
                                        Lớp: <span className={'text-danger'}>{
                                        // @ts-ignore
                                        subjectsDetails.data.subjectTeaching?.name}</span>
                                    </div>
                                </div>
                            </div>
                        }
                        {faculties && faculties.length > 0 ? (
                            // @ts-ignore
                            classSubjectSchedule.length ?
                                <div className='mt-2 w-100'>
                                    <div className='pl-1 text-sm font-semibold mb-2 text-gray-600 '>
                                        Khoa
                                    </div>
                                    <select
                                        disabled={true}
                                        className='input-custom block
												w-100 px-3 py-2 border border-gray-300
												placeholder-gray-500 rounded-md
												focus:outline-none focus:ring-1
												focus:ring-blue-700'
                                        // @ts-ignore
                                        value={fId}
                                        onChange={(e) => {

                                        }}>
                                        {faculties.map((item: any) => {
                                            return (
                                                <option
                                                    value={item.id}
                                                    key={item.id}>
                                                    {item.name}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </div> : ''
                        ) : (
                            ''
                        )}
                        {faculties && faculties.length > 0 ? (
                            // @ts-ignore
                            classSubjectSchedule.length ?
                                <div className='mt-2 w-100'>
                                    <div className='pl-1 text-sm font-semibold mb-2 text-gray-600 '>
                                        Lớp
                                    </div>
                                    <select
                                        disabled={true}
                                        className='input-custom block
												w-100 px-3 py-2 border border-gray-300
												placeholder-gray-500 rounded-md
												focus:outline-none focus:ring-1
												focus:ring-blue-700'
                                        // @ts-ignore
                                        value={cId}
                                        onChange={(e) => {
                                            // console.log('classID' + e.target.value);
                                            // console.log('subjectScheduleTmp classId: ' + subjectScheduleTmp.classId);
                                            // setSubjectScheduleTmp({...subjectScheduleTmp, classId: e.target.value});
                                        }}>
                                        {findClassWithFacultyId()?.map((item: any) => {
                                            return (
                                                <option
                                                    value={item.id}
                                                    key={item.id}>
                                                    {item.name}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </div> : ''
                        ) : (
                            ''
                        )}
                        {subjects && subjects.length > 0 ? (
                            // @ts-ignore
                            classSubjectSchedule.length ?
                                <div className='mt-2 w-100'>
                                    <div className='pl-1 text-sm font-semibold mb-2 text-gray-600 '>
                                        Môn học
                                    </div>
                                    <select
                                        className='input-custom block
												w-100 px-3 py-2 border border-gray-300
												placeholder-gray-500 rounded-md
												focus:outline-none focus:ring-1
												focus:ring-blue-700'
                                        // @ts-ignore
                                        value={subjectScheduleTmp.subjectId}
                                        onChange={(e) => {
                                            getClass(e.target.value);
                                        }}>
                                        {subjects.map((item: any) => {
                                            return (
                                                <option
                                                    value={item.id}
                                                    key={item.id}>
                                                    {item.name}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </div> : ''
                        ) : (
                            ''
                        )}
                        {
                            // @ts-ignore
                            classSubjectSchedule.length ?
                                <div className='mt-2 w-100'>
                                    <div className='pl-1 text-sm font-semibold mb-2 text-gray-600 '>
                                        Lớp môn học
                                    </div>
                                    <select
                                        className='input-custom block
												w-100 px-3 py-2 border border-gray-300
												placeholder-gray-500 rounded-md
												focus:outline-none focus:ring-1
												focus:ring-blue-700'
                                        // @ts-ignore
                                        value={subjectScheduleTmp.subjectTeachingId}
                                        onChange={(e) => {
                                            changeClass(e.target.value);
                                        }}>
                                        {classLists?.length > 0 ? classLists.map((item: any) => {
                                            return (
                                                <option
                                                    value={item.id}
                                                    key={item.id}>
                                                    {item.name}
                                                </option>
                                            );
                                        }) : <option
                                            value={''}
                                            key={''}>
                                            Chọn môn học để lấy danh sách lớp
                                        </option>}
                                    </select>
                                </div> : ''
                        }
                        {
                            classSubjectSchedule.length ? <div>
                                <div>
                                    <div className='pl-1 text-sm font-semibold mb-2 text-gray-600 '>
                                        {subjectScheduleTmp.isRepeatedWeekly ? 'Từ ngày' : 'Ngày học'}
                                    </div>
                                    <DatePicker
                                        className='appearance-none block
									w-full px-3 py-2 border border-gray-300
									placeholder-gray-500 rounded-md
									focus:outline-none focus:ring-1
									focus:ring-blue-700'
                                        selected={new Date(subjectScheduleTmp.startDate)}
                                        onChange={(date) => {
                                            setSubjectScheduleTmp({
                                                ...subjectScheduleTmp,
                                                startDate: date
                                            });
                                        }}
                                        minDate={new Date(subjectScheduleTmp.startDate)}
                                        dateFormat='dd/MM/yyyy'
                                    />
                                </div>
                                {
                                    !subjectScheduleTmp.isRepeatedWeekly ? '' :
                                        <div className='mt-2'>
                                            <div className='pl-1 text-sm font-semibold mb-2 text-gray-600 '>
                                                Đến ngày
                                            </div>
                                            <DatePicker
                                                className='appearance-none block
									w-full px-3 py-2 border border-gray-300
									placeholder-gray-500 rounded-md
									focus:outline-none focus:ring-1
									focus:ring-blue-700'
                                                selected={new Date(subjectScheduleTmp.endDate)}
                                                onChange={(date) => {
                                                    setSubjectScheduleTmp({
                                                        ...subjectScheduleTmp,
                                                        endDate: date
                                                    });
                                                }}
                                                minDate={new Date(subjectScheduleTmp.endDate)}
                                                dateFormat='dd/MM/yyyy'
                                            />
                                        </div>
                                }
                            </div> : <div>
                                <div className='pl-1 text-sm font-semibold mb-2 text-gray-600 '>
                                    Ngày học
                                </div>
                                <DatePicker
                                    className='appearance-none block
									w-full px-3 py-2 border border-gray-300
									placeholder-gray-500 rounded-md
									focus:outline-none focus:ring-1
									focus:ring-blue-700'
                                    selected={new Date(subjectScheduleTmp.startDate)}
                                    onChange={(date) => {
                                        setSubjectScheduleTmp({
                                            ...subjectScheduleTmp,
                                            startDate: date
                                        });
                                    }}
                                    dateFormat='dd/MM/yyyy'
                                />
                            </div>
                        }

                        {rooms && rooms.length > 0 ? (
                            <div className='mt-2'>
                                <div className='pl-1 text-sm font-semibold mb-2 text-gray-600 '>
                                    Phòng học
                                </div>
                                <select
                                    className='input-custom block
												w-100 px-3 py-2 border border-gray-300
												placeholder-gray-500 rounded-md
												focus:outline-none focus:ring-1
												focus:ring-blue-700'
                                    // @ts-ignore
                                    value={subjectScheduleTmp.roomId}
                                    onChange={(e) => {
                                        setSubjectScheduleTmp({
                                            ...subjectScheduleTmp,
                                            roomId: e.target.value
                                        });
                                    }}>
                                    {rooms.map((item: any) => {
                                        return (
                                            <option
                                                value={item.id}
                                                key={item.id}>
                                                {item.name}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                        ) : (
                            ''
                        )}
                        <div style={{ paddingTop: '20px' }}>
                            <div className='pl-1 text-sm font-semibold mb-2 text-gray-600 '>
                                <div className={'flex flex-row justify-between'}>
                                    <div>Giờ bắt đầu</div>
                                    <div>
                                        <button className={'btn btn-sm bg-blue-800 text-white mr-1'}
                                                onClick={() => setTimeInput({
                                                    ...timeInput,
                                                    startTime: '08:00',
                                                    endTime: '11:30'
                                                })}>Buổi SA
                                        </button>
                                        <button className={'btn btn-sm bg-yellow-500 text-white mr-1'}
                                                onClick={() => setTimeInput({
                                                    ...timeInput,
                                                    startTime: '13:30',
                                                    endTime: '16:45'
                                                })}>Buổi CH
                                        </button>
                                        <button className={'btn btn-sm bg-green-500 text-white'}
                                                onClick={() => setTimeInput({
                                                    ...timeInput,
                                                    startTime: '17:00',
                                                    endTime: '20:00'
                                                })}>Buổi TỐI
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <input
                                name='text'
                                type='time'
                                required
                                className='appearance-none block
									w-full px-3 py-2 border border-gray-300
									placeholder-gray-500 rounded-md
									focus:outline-none focus:ring-1
									focus:ring-blue-700'
                                placeholder='Giờ bắt đầu buổi học'
                                onChange={(e) => {
                                    setTimeInput({
                                        ...timeInput,
                                        startTime: e.target.value,
                                        endTime: e.target.value == '08:00' ? '11:30' : e.target.value == '13:30' ? '16:45' : timeInput.endTime
                                    });
                                }}
                                value={timeInput.startTime}
                            />
                        </div>
                        <div style={{ paddingTop: '20px' }}>
                            <div className='pl-1 text-sm font-semibold mb-2 text-gray-600 '>
                                Giờ kết thúc
                            </div>
                            <input
                                name='text'
                                type='time'
                                required
                                className='appearance-none block
									w-full px-3 py-2 border border-gray-300
									placeholder-gray-500 rounded-md
									focus:outline-none focus:ring-1
									focus:ring-blue-700'
                                placeholder='Giờ kết thúc'
                                onChange={(e) => {
                                    setTimeInput({
                                        ...timeInput,
                                        endTime: e.target.value,
                                        startTime: e.target.value == '11:30' ? '08:00' : e.target.value == '16:45' ? '13:30' : timeInput.startTime
                                    });
                                }}
                                min={timeInput.startTime}
                                value={timeInput.endTime}
                            />
                        </div>

                    </Modal.Body>
                    <Modal.Footer style={{ justifyContent: 'space-between' }}>
                        {
                            // @ts-ignore
                            classSubjectSchedule.length ?
                                <div className={'flex flex-row justify-content-between w-100'}>
                                    <div
                                        onClick={() => {
                                            onSaveSubjectSchedule();
                                        }}>
                                        <Button icon={<i className='fad fa-save'></i>}
                                                label={'Lưu & Đóng'} />
                                    </div>
                                    <div
                                        onClick={() => {
                                            onSaveContinueSubjectSchedule();
                                        }}>
                                        <Button icon={<i className='fas fa-share-all'></i>}
                                                label='Lưu & Tiếp tục' />
                                    </div>
                                </div> :
                                <div className={'flex flex-row justify-content-between w-100'}>
                                    <div
                                        onClick={() => {
                                            isDeleteSubjectSchedule();
                                        }}>
                                        <Button color={'bg-red-600'} hoverColor={'bg-red-800'}
                                                icon={<i className='fas fa-trash'></i>} label='Xóa buổi học' />
                                    </div>
                                    <div
                                        onClick={() => {
                                            onUpdateSubjectSchedule();
                                        }}>
                                        <Button icon={<i className='fas fa-save'></i>}
                                                label={'Lưu lại'} />
                                    </div>
                                </div>
                        }
                    </Modal.Footer>
                </Modal>
            </div>
            <div>
                <Modal
                    show={modalShowExportSubjectSchedule}
                    aria-labelledby='contained-modal-title-vcenter'
                    onHide={() => setModalShowExportSubjectSchedule(false)}
                    centered>
                    <Modal.Header closeButton>
                        <Modal.Title id='contained-modal-title-vcenter'>
                            <div className={'flex flex-column'}>
                                Xuất thời khóa biểu
                            </div>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className='mt-2 w-100'>
                            <div className='pl-1 text-sm font-semibold mb-2 text-gray-600 '>
                                Lớp
                            </div>
                            <input
                                name='classId'
                                type='text'
                                required
                                className='appearance-none block
									w-full px-3 py-2 border border-gray-300
									placeholder-gray-500 rounded-md
									focus:outline-none focus:ring-1
									focus:ring-blue-700'
                                placeholder='Lớp'
                                onChange={(e) => {

                                }}
                                value={classChoose}
                            />
                        </div>
                        <div>
                            <div className='pl-1 text-sm font-semibold mb-2 text-gray-600 '>
                                Ngày bắt đầu
                            </div>
                            <DatePicker
                                className='appearance-none block
									w-full px-3 py-2 border border-gray-300
									placeholder-gray-500 rounded-md
									focus:outline-none focus:ring-1
									focus:ring-blue-700'
                                selected={new Date(subjectScheduleExport.startDate)}
                                onChange={(date) => {
                                    setSubjectScheduleExport({
                                        ...subjectScheduleExport,
                                        startDate: date
                                    });
                                }}
                                // minDate={new Date(subjectScheduleExport.startDate)}
                                dateFormat='dd/MM/yyyy'
                            />
                        </div>
                        <div>
                            <div className='pl-1 text-sm font-semibold mb-2 text-gray-600 '>
                                Ngày kết thúc
                            </div>
                            <DatePicker
                                className='appearance-none block
									w-full px-3 py-2 border border-gray-300
									placeholder-gray-500 rounded-md
									focus:outline-none focus:ring-1
									focus:ring-blue-700'
                                selected={new Date(subjectScheduleExport.endDate)}
                                onChange={(date) => {
                                    setSubjectScheduleExport({
                                        ...subjectScheduleExport,
                                        endDate: date
                                    });
                                }}
                                minDate={new Date(subjectScheduleExport.startDate)}
                                dateFormat='dd/MM/yyyy'
                            />
                        </div>
                    </Modal.Body>
                    <Modal.Footer style={{ justifyContent: 'space-between' }}>
                        <div className={'flex flex-row justify-content-between w-100'}>
                            <div
                                onClick={() => {
                                    setModalShowExportSubjectSchedule(false);
                                }}>
                                <Button color={'bg-red-600'} hoverColor={'bg-red-800'}
                                        icon={<i className='fas fa-times-circle'></i>} label='Hủy' />
                            </div>
                            <div
                                onClick={() => {
                                    exportSubjectSchedules();
                                }}>
                                <Button icon={<i className='fas fa-file-alt'></i>}
                                        label={'Xuất excel'} />
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div>
            <ConfirmDialog
                confirmDialog={confirmDialog}
                setConfirmDialog={setConfirmDialog}
                deleteItem={deleteItem}
            />

            <ErrorDialog
                errorDialog={errDialog}
                setErrorDialog={setErrDialog}
            />
        </DefaultLayout>
    );
}


export default SubjectClass;
